import cx from 'classnames';
import type React from 'react';
import { Icons } from '@/shared/Icons/Icons';
import styles from './styles.module.css';

interface IconButtonProps {
  icon: React.ReactNode;
  onClick?: () => void;
  color?: 'blue' | 'red' | 'heart';
  disabled?: boolean;
  isActive?: boolean;
  className?: string;
  classNameActive?: string;
  ariaLabel?: string;
}

const IconButtonForPass: React.FC<IconButtonProps> = ({
  onClick = () => {},
  disabled = false,
  isActive = false,
  color = 'blue',
  className = '',
  ariaLabel = '',
}) => {
  return (
    <>
      <button
        className={cx(
          styles[color],
          styles.iconButton,
          isActive ? styles.activePass : '',
          className,
        )}
        disabled={disabled}
        type="button"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onClick();
        }}
        aria-label={ariaLabel}
      >
        {isActive ? <Icons.Show /> : <Icons.NoShow />}
      </button>
    </>
  );
};

export default IconButtonForPass;
